import { StyleSheet } from "react-native";

export const settingsStyles = StyleSheet.create({
  listHeader: {
    marginHorizontal: 10,
    marginBottom: 10,
  },
});
